// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2ACa8","name":"Header_name__1b_pP","birthday":"Header_birthday__3EfFL","skeleton":"Header_skeleton__36PsD"};